<template>

	<el-input
		type="number"
		ref="input"
		class="input-llood-number"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
	/>

</template>

<script>
	export default {
		name: 'InputLloodNumber',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) {
					this.$emit('input', val) 
				}

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.select(), 200) }

		}
	}
</script>

<style lang="scss">
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>
